<template>
	<div class="sf-input-group-wrapper">
		<!--날짜검색-->
		<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC001393') }}</span>
		<div class="search-option-wrapper__normal">
			<el-select v-model="data" @change="change">
				<!--전체-->
				<el-option :label="getMessage_('MWCC000753')" value=""></el-option>
				<el-option :key="index" v-for="(item, index) in pwaDdList" :label="item.commCdName" :value="item.commCd"></el-option>
			</el-select>
		</div>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/ceqi/PwaApcn/store/helpers';
export default {
	data() {
		return {
			data: null
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		change(value) {
			this.setSearchParam_({ key: 'prcPwaDd', value: value }).then(() => {
				this.$emit('reload', 1, 10);
			});
		},
		processInfo() {
			this.data = this.searchParams.prcPwaDd;
		}
	},
	created() {
		if (this.searchParams.prcPwaDd == null || this.searchParams.prcPwaDd == '') this.searchParams.prcPwaDd = '';
		this.data = this.searchParams.prcPwaDd;
	}
};
</script>

<style></style>
